<template>
  <el-tooltip class="item" effect="dark" placement="top-start" :content="title">
    <span>
      <el-popover ref="popover" placement="bottom">
        <p>
          <el-icon class="el-popconfirm__icon">
            <InfoFilledElementIcon />
          </el-icon>
          Are you sure to {{ title }} it?
        </p>
        <el-input
          v-if="withInput"
          v-model="reason"
          autosize
          placeholder="Please enter the reason"
          type="textarea"
        />
        <div style="text-align: right; margin: 0">
          <el-button
            size="small"
            :type="type"
            :disabled="isReasonRequired && !reason"
            @click="click"
          >
            OK
          </el-button>
        </div>
        <template #reference>
          <el-button
            v-if="isCircleBtn"
            size="small"
            :type="type"
            :icon="icon"
            :class="btnClass"
            circle
            plain
          />
          <el-button
            v-else
            size="small"
            :type="type"
            :icon="icon"
            :class="btnClass"
            :round="true"
            plain
          >
            {{ title }}
          </el-button>
        </template>
      </el-popover>
    </span>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'

type PopConfig = {
  icon: string
  type: string
  title: string
  withText?: boolean
  withInput?: boolean
  withInputForStaff?: boolean
}

const EVENTS: Record<string, PopConfig> = {
  send_to_review: {
    icon: 'ViewElementIcon',
    type: 'default',
    title: 'Send to review',
    withText: true
  },
  approve: {
    icon: 'CheckElementIcon',
    type: 'success',
    title: 'Approve'
  },
  reject: {
    icon: 'CircleCloseElementIcon',
    type: 'danger',
    title: 'Reject',
    withInput: true
  },
  reject_deal: {
    icon: 'CircleCloseElementIcon',
    type: 'danger',
    title: 'Reject deal',
    withInput: true
  },
  manager_approve: {
    icon: 'CheckElementIcon',
    type: 'success',
    title: 'Approve deal'
  },
  pause: {
    icon: 'VideoPauseElementIcon',
    type: 'warning',
    title: 'Stop'
  },
  unpause: {
    icon: 'CaretRightElementIcon',
    type: 'primary',
    title: 'Run'
  },
  stop: {
    icon: 'DeleteElementIcon',
    type: 'info',
    title: 'Archive',
    withInputForStaff: true
  },
  verify: {
    icon: 'CheckElementIcon',
    type: 'primary',
    title: 'Verify!'
  }
}
export default defineComponent({
  name: 'PossibleActionButton',
  props: {
    event: {
      type: String,
      required: true
    },
    state: {
      type: String,
      default: ''
    },
    isStaff: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const reason = ref('')
    const popover = ref<any>(null)

    const icon = computed(() => {
      return EVENTS[props.event].icon
    })
    const title = computed(() => {
      let text = EVENTS[props.event].title
      if (props.state === 'rejected') {
        text = `${text} again`
      }
      return text
    })
    const type = computed(() => {
      return EVENTS[props.event].type
    })
    const withInput = computed(() => {
      const config = EVENTS[props.event]
      if (config.withInput) return true
      if (config.withInputForStaff && props.isStaff) return true
      return false
    })
    const isReasonRequired = computed(() => {
      const config = EVENTS[props.event]
      return config.withInputForStaff && props.isStaff
    })
    const isCircleBtn = computed(() => {
      return !EVENTS[props.event].withText
    })
    const btnClass = computed(() => {
      return EVENTS[props.event].withText ? 'mr-1' : 'small-action-btn'
    })
    const click = () => {
      if (popover.value?.hide) {
        popover.value.hide()
      }
      context.emit('invoke', props.event, reason.value)
    }
    return {
      icon,
      title,
      click,
      type,
      isCircleBtn,
      reason,
      withInput,
      isReasonRequired,
      btnClass,
      popover
    }
  }
})
</script>

<style lang="scss" scoped>
.small-action-btn {
  margin-right: 3px;
}

.el-textarea {
  margin-bottom: 10px;
}

.el-icon-info {
  color: red;
}
</style>
